import React from "react";
import type {Table as RTable} from "@tanstack/react-table";
import StyledButton from "../../styledButton/StyledButton";

import styles from "./Pagination.module.scss";

type PaginationProps<T> = {
  table: RTable<T>;
  className?: string;
};

export default function Pagination<T>({table, className}: PaginationProps<T>) {
  return (
    <div className={styles.pagination}>
      <div
        className={styles.navArrows}
        onClick={() =>
          !table.getCanPreviousPage() ? null : table.previousPage()
        }
      >
        {"<"}
      </div>

      <span className={styles.pageInfo}>
        Page {table.getState().pagination.pageIndex + 1} of{" "}
        {table.getPageCount()}
      </span>

      <div
        className={styles.navArrows}
        onClick={() => (!table.getCanNextPage() ? null : table.nextPage())}
      >
        {">"}
      </div>
    </div>
  );
}
